import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { LazyLoadImage } from "react-lazy-load-image-component";
import MultiLingualContent from "../../../languages/MultiLingualContent";
import kruha1 from "../../../assets/images/kruha1.jpeg";
import kruha2 from "../../../assets/images/kruha2.jpeg";
import kruhaArticle from "../../../assets/articles/קרוחה בשירות הראפואה.pdf";
import BackButton from "../../backButton";

const Kruha = () => {
  return (
    <div className="inner-section" id="kshichit">
      <Helmet>
        <title>פטרידע - הפטריה קשיחית</title>
        <meta
          name="description"
          content="הפטריה קשיחית - Stereum: תאור, זיהוי ותמונות"
        />
      </Helmet>
      <BackButton path="/#types-and-species" />
      <h2>
        <MultiLingualContent contentID="kruha" />
      </h2>
      <>
        <div className="informationText">
          <p>
            <MultiLingualContent contentID="kruhaText1" />
          </p>
          <p>
            <MultiLingualContent contentID="kruhaText2" />
          </p>
          <p>
            <MultiLingualContent contentID="kruhaText3" />
          </p>
          <p>
            <MultiLingualContent contentID="kruhaText4" />
          </p>
          <br />
          <p>
            <b>
              <MultiLingualContent contentID="kruhaText5Bold" />
            </b>
          </p>
          <p>
            <MultiLingualContent contentID="kruhaText6" />
          </p>
          <div className="informationImages">
            <div className="imgWrapper">
              <LazyLoadImage src={kruha1} alt="קרוחה" />
              <p>
                <MultiLingualContent contentID="kruhaImg1" />
              </p>
            </div>
          </div>
          <br />
          <p>
            <b>
              <MultiLingualContent contentID="kruhaText7Bold" />
            </b>
          </p>
          <p>
            <MultiLingualContent contentID="kruhaText8" />
          </p>
          <div className="informationImages">
            <div className="imgWrapper">
              <LazyLoadImage src={kruha2} alt="קרוחה" />
              <p>
                <MultiLingualContent contentID="kruhaImg2" />
              </p>
            </div>
          </div>
          <br />
          <br />
          <Link to={kruhaArticle} target="_blank" download>
            <MultiLingualContent contentID="kruhaText9" />
          </Link>
        </div>
      </>
    </div>
  );
};

export default Kruha;
